import { Outlet } from 'react-router-dom';

export default function Clients() {
  return (
    <>
      <Outlet />
    </>
  );
}
